import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {
  projects = [
    {
      id: 'barber-booking',
      src: 'assets/Images/Projects/barber-booking.gif',
      infoTitle: 'Hair Appointment Booking',
      para1: 'Tired of Wasting time at a Hair Salon to wait your turn? Well wait no longer!!!',
      para2: 'Introducing BarberBooky - Book your next hair appointment with your favourite barber in no time. You\'re Welcome!',
      animation: 'fadeInLeft',
      btnText: 'Work In Progress'
    },
    {
      id: 'daily-sheet',
      src: 'assets/Images/Projects/daily-sheet.gif',
      infoTitle: 'Hotel Operation Sheet',
      para1: 'A Web Application built to facilitate daily operations in a hotel\'s housekeeping department.',
      para2: 'Built with modern Full Stack technologies including Angular 10, NodeJS, MongoDB',
      btnLink: 'https://nghdailysheet.web.app',
      animation: 'slideInLeft',
    },
    {
      id: 'inventory',
      src: 'assets/Images/Projects/inventory.gif',
      infoTitle: 'Inventory Recorder',
      para1: 'Never lose track of your supplies.',
      para2: 'Create and maintain inventory records on Daily, Monthly, or Yearly basis',
      animation: 'fadeInRight',
      btnLink: 'https://nghdailysheet.web.app/inventory',
    },
    {
      id: 'hk-list',
      src: 'assets/Images/Projects/hk-list.gif',
      infoTitle: 'Task Scheduler',
      para1: 'Ensure smooth and efficient operations by tracking Maintenance Tasks',
      para2: 'Create and assigns Tasks based on Areas and Frequency',
      animation: 'fadeInLeft',
      btnLink: 'https://nghdailysheet.web.app/hklist',
    },
  ];

  constructor() { }

  ngOnInit() {
  }

}
